import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { ellipsis } from '@synoptic/ui-kit/utility.css.ts';
import { style } from '@vanilla-extract/css';

export const streamAuthor = style({
  display: 'flex',
  alignItems: 'center',
  gap: space.s8,
  ...responsiveStyle({
    mobile: {
      maxWidth: '100%',
      flexGrow: 1,
      minWidth: 0,
      marginLeft: 0,
    },
    tablet: {},
    laptop: {
      marginLeft: 'auto',
    },
  }),
});

export const streamAuthorUsernameContainer = style({
  display: 'flex',
  minWidth: 0,
});

export const streamCardUsername = style([
  {
    ...typography.bodySm,
    display: 'block',
    width: '100%',
    color: themeVars.container.foreground.secondary,

    selectors: {
      [`&:hover &`]: {
        color: themeVars.color.text.brand,
      },
    },
  },
  ellipsis,
]);
